var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useRef, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import '../../../styles/widgets/clock/clockmanipulative.scss';
import { DataContext } from '../../../player/DataContext';
import customEventHandler from '../../../helper/customEvents';
import ButtonComponent from '../../../components/ButtonComponent';
import globalStore from '../../../store';
import { selectTool } from '../../../helper/helper';
import { playAudio, stopAudio } from '../../../helper/audioHelper';
import { saveState } from '../../../helper/stateManagerHelper';
import { announce } from '../../../helper/announcer';
import { useDuplicateAnnounce, useCreationAnnounce } from '../../../helper/hooks/useDuplicateAnnounce';
import { useMultiSelectDragSource } from '../../../helper/hooks/useMultiSelectDrag';
import { registerMultiSelectSaveEntries } from '../../../helper/multiSelectSaveCoordinator';
var IS_TOUCH_DEVICE = typeof window !== 'undefined' && !!((_a = window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, '(pointer: coarse)').matches);
export default function Timer(props) {
    var _a, _b, _c, _d, _e, _f;
    var _clockData = props._clockData, onClockDataChange = props.onClockDataChange, updateStyleOnwhiteboard = props.isOnWhiteBoard;
    var t = useTranslation().t;
    var timerDuplicateLabel = useDuplicateAnnounce((_a = _clockData.id) !== null && _a !== void 0 ? _a : '', t('text.manipulativeTimer'));
    var timerCreationLabel = useCreationAnnounce((_b = _clockData.id) !== null && _b !== void 0 ? _b : '', t('text.manipulativeTimer'));
    var id = _clockData.id, _g = _clockData.timer_minutes, timer_minutes = _g === void 0 ? 10 : _g, _h = _clockData.timer_seconds, timer_seconds = _h === void 0 ? 0 : _h, timer_current_minutes = _clockData.timer_current_minutes, timer_current_seconds = _clockData.timer_current_seconds, propIsRunning = _clockData.timer_is_running, propIsPaused = _clockData.timer_is_paused, scale = _clockData.scale, center = _clockData.center, lock = _clockData.lock;
    /** ---------------- DATA STORE FROM GAME CONTROLLER ---------------- */
    var _j = useContext(DataContext), selectedTool = _j.selectedTool, setSelectedTool = _j.setSelectedTool, setManipulative = _j.setManipulative, manipulative = _j.manipulative, setActiveManipulator = _j.setActiveManipulator, setManiplulatorComponentVisible = _j.setManiplulatorComponentVisible, setSelectedManipulativeId = _j.setSelectedManipulativeId, panningEnable = _j.panningEnable, selectedManipulativeId = _j.selectedManipulativeId, setContextMenu = _j.setContextMenu;
    var _k = useMultiSelectDragSource(id !== null && id !== void 0 ? id : '', selectedTool), startMultiDrag = _k.startMultiDrag, moveMultiDrag = _k.moveMultiDrag, endMultiDrag = _k.endMultiDrag;
    var btnConfig = globalStore.useStoreState(function (store) { return store.jsonDataStore; }).btnConfig;
    var zoomLevel = globalStore.useStoreState(function (store) { return store.playerStore; }).zoomLevel;
    //    UseSate Variables --------------------------------------------------------------------------------------------------------------------------------------
    var _l = useState(timer_current_minutes !== null && timer_current_minutes !== void 0 ? timer_current_minutes : (timer_minutes || 10)), timerMinute = _l[0], setTimerMinutes = _l[1];
    var _m = useState(timer_current_seconds !== null && timer_current_seconds !== void 0 ? timer_current_seconds : (timer_seconds || 0)), timerSecond = _m[0], setTimerSeconds = _m[1];
    var timerValueRef = useRef({
        minutes: timer_current_minutes !== null && timer_current_minutes !== void 0 ? timer_current_minutes : (timer_minutes || 10),
        seconds: timer_current_seconds !== null && timer_current_seconds !== void 0 ? timer_current_seconds : (timer_seconds || 0),
    });
    var _o = useState(false), isFocused = _o[0], setIsFocused = _o[1];
    var _p = useState(false), isRunning = _p[0], setIsRunning = _p[1];
    var _q = useState(false), isDraggingSelf = _q[0], setIsDraggingSelf = _q[1];
    var _r = useState(updateStyleOnwhiteboard), onWhiteBoard = _r[0], setonWhiteBoard = _r[1]; //----------
    var _s = useState(scale || 1), scaling = _s[0], setScaling = _s[1]; //----------
    // (window as any)['scaling'] = scaling;
    var intervalRef = useRef(null);
    var btnRef = useRef([null, null, null]);
    var _t = useState([
        { id: 'start', disable: false },
        { id: 'pause', disable: true },
        { id: 'stop', disable: true },
    ]), controlBtns = _t[0], setControlBtns = _t[1];
    // ----------------------------------------------------------------------------------------------------------------------------------------------------------
    var wrapperRef = useRef(null);
    var positionDragRef = useRef(null);
    var dragStartPositionRef = useRef(null);
    var currentPositionRef = useRef(null);
    var isLocalUpdateRef = useRef(false);
    var timerStartValuesRef = useRef(null);
    /** Format numbers as two digits */
    var pad = function (num) { return String(num).padStart(2, '0'); };
    useEffect(function () {
        setonWhiteBoard(function (prev) { return (prev = updateStyleOnwhiteboard); });
        setControlBtns(function (prev) {
            return prev.map(function (btn) {
                if (btn.id === 'start')
                    return __assign(__assign({}, btn), { disable: false });
                else
                    return __assign({}, btn);
            });
        });
    }, [updateStyleOnwhiteboard]);
    useEffect(function () {
        setTimerMinutes(timer_minutes);
        setTimerSeconds(timer_seconds);
        timerValueRef.current = { minutes: timer_minutes, seconds: timer_seconds };
    }, [timer_minutes, timer_seconds]);
    // Sync current countdown values from props (for undo/redo)
    useEffect(function () {
        if (isLocalUpdateRef.current) {
            isLocalUpdateRef.current = false;
            return;
        }
        if (timer_current_minutes !== undefined && timer_current_seconds !== undefined) {
            setTimerMinutes(timer_current_minutes);
            setTimerSeconds(timer_current_seconds);
            timerValueRef.current = { minutes: timer_current_minutes, seconds: timer_current_seconds };
            // If timer is running during undo/redo, stop it
            if (isRunning) {
                if (intervalRef.current)
                    clearInterval(intervalRef.current);
                setIsRunning(false);
                setControlBtns(function (prev) {
                    return prev.map(function (btn) {
                        if (btn.id === 'start')
                            return __assign(__assign({}, btn), { disable: false });
                        else if (btn.id === 'pause')
                            return __assign(__assign({}, btn), { disable: true });
                        else
                            return __assign({}, btn);
                    });
                });
            }
        }
    }, [timer_current_minutes, timer_current_seconds]);
    // Sync running state from props (done resets, cancel restores paused state)
    useEffect(function () {
        if (propIsRunning === false && !isRunning) {
            var _a = timerValueRef.current, minutes = _a.minutes, seconds = _a.seconds;
            var atZero_1 = minutes === 0 && seconds === 0;
            var atStart_1 = minutes === timer_minutes && seconds === timer_seconds;
            setControlBtns(function (prev) {
                return prev.map(function (btn) {
                    if (btn.id === 'start')
                        return __assign(__assign({}, btn), { disable: atZero_1 });
                    if (btn.id === 'pause')
                        return __assign(__assign({}, btn), { disable: true });
                    if (btn.id === 'stop')
                        return __assign(__assign({}, btn), { disable: atStart_1 });
                    return btn;
                });
            });
        }
    }, [propIsRunning, propIsPaused]);
    // Sync scale from props (for undo/redo)
    useEffect(function () {
        setScaling(scale || 1);
    }, [scale]);
    /** ---------------- IS FOCUSED ---------------- */
    var prevSelectedToolRef = useRef([]);
    useEffect(function () {
        var wasFocused = prevSelectedToolRef.current.includes(id);
        var nowFocused = selectedTool.includes(id);
        prevSelectedToolRef.current = selectedTool;
        setIsFocused(nowFocused);
        if (nowFocused && !wasFocused && onWhiteBoard && wrapperRef.current) {
            setTimeout(function () {
                var _a, _b, _c;
                // Don't steal focus from the context menu
                if ((_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.closest('.shape-context-menu'))
                    return;
                (_c = (_b = wrapperRef.current) === null || _b === void 0 ? void 0 : _b.querySelector('.dummy_btn')) === null || _c === void 0 ? void 0 : _c.focus();
            }, 100);
        }
    }, [selectedTool]);
    /** Start countdown */
    var startTimer = function () {
        if (isRunning)
            return;
        if (timerMinute === 0 && timerSecond === 0)
            return;
        // Capture current values for undo/redo
        timerStartValuesRef.current = {
            minutes: timerValueRef.current.minutes,
            seconds: timerValueRef.current.seconds,
        };
        setIsRunning(true);
        isLocalUpdateRef.current = true;
        setManipulative(function (prev) {
            return prev.map(function (item) {
                return item.data.id === id
                    ? __assign(__assign({}, item), { data: __assign(__assign({}, item.data), { timer_is_running: true, timer_is_paused: false }) }) : item;
            });
        });
        setControlBtns(function (prev) {
            return prev.map(function (btn) {
                if (btn.id === 'start')
                    return __assign(__assign({}, btn), { disable: true });
                else
                    return __assign(__assign({}, btn), { disable: false });
            });
        });
        // Focus pause button (now the primary action)
        requestAnimationFrame(function () { var _a; return (_a = btnRef.current[1]) === null || _a === void 0 ? void 0 : _a.focus(); });
        intervalRef.current = setInterval(function () {
            var _a = timerValueRef.current, minutes = _a.minutes, seconds = _a.seconds;
            // Check if timer has reached 00:00 - stop immediately
            if (minutes === 0 && seconds === 0) {
                clearInterval(intervalRef.current);
                setIsRunning(false);
                playAudio('timerStopped');
                announce(t('text.timerComplete'));
                setControlBtns(function (prev) {
                    return prev.map(function (btn) {
                        if (btn.id === 'start')
                            return __assign(__assign({}, btn), { disable: true });
                        else if (btn.id === 'pause')
                            return __assign(__assign({}, btn), { disable: true });
                        else if (btn.id === 'stop')
                            return __assign(__assign({}, btn), { disable: false });
                        else
                            return __assign({}, btn);
                    });
                });
                return;
            }
            // Calculate new values
            var newMinutes = minutes;
            var newSeconds = seconds;
            if (seconds > 0) {
                newSeconds = seconds - 1;
            }
            else {
                // seconds is 0, borrow from minutes
                newMinutes = minutes - 1;
                newSeconds = 59;
            }
            // Update ref and state
            timerValueRef.current = { minutes: newMinutes, seconds: newSeconds };
            setTimerMinutes(newMinutes);
            setTimerSeconds(newSeconds);
            // Check if we just hit 00:00
            if (newMinutes === 0 && newSeconds === 0) {
                clearInterval(intervalRef.current);
                setIsRunning(false);
                playAudio('timerStopped');
                setControlBtns(function (prev) {
                    return prev.map(function (btn) {
                        if (btn.id === 'start')
                            return __assign(__assign({}, btn), { disable: true });
                        else if (btn.id === 'pause')
                            return __assign(__assign({}, btn), { disable: true });
                        else if (btn.id === 'stop')
                            return __assign(__assign({}, btn), { disable: false });
                        else
                            return __assign({}, btn);
                    });
                });
                // Save state for undo/redo (auto-stop at 00:00)
                if (timerStartValuesRef.current) {
                    saveState({
                        type: id,
                        id: id.split('_')[1],
                        propertyName: 'completeData',
                        old: JSON.stringify({
                            timer_current_minutes: timerStartValuesRef.current.minutes,
                            timer_current_seconds: timerStartValuesRef.current.seconds,
                        }),
                        new: JSON.stringify({
                            timer_current_minutes: 0,
                            timer_current_seconds: 0,
                        }),
                    });
                    timerStartValuesRef.current = null;
                }
                // Update manipulative
                isLocalUpdateRef.current = true;
                setManipulative(function (prev) {
                    return prev.map(function (item) {
                        return item.data.id === id
                            ? __assign(__assign({}, item), { data: __assign(__assign({}, item.data), { timer_current_minutes: 0, timer_current_seconds: 0, timer_is_running: false, timer_is_paused: false }) }) : item;
                    });
                });
            }
        }, 1000);
    };
    /** Pause the timer */
    var pauseTimer = function () {
        if (intervalRef.current)
            clearInterval(intervalRef.current);
        setIsRunning(false);
        setControlBtns(function (prev) {
            return prev.map(function (btn) {
                if (btn.id === 'start')
                    return __assign(__assign({}, btn), { disable: false });
                else if (btn.id === 'pause')
                    return __assign(__assign({}, btn), { disable: true });
                else
                    return __assign({}, btn);
            });
        });
        // Focus start button (now the primary action)
        requestAnimationFrame(function () { var _a; return (_a = btnRef.current[0]) === null || _a === void 0 ? void 0 : _a.focus(); });
        // Save state for undo/redo
        if (timerStartValuesRef.current) {
            saveState({
                type: id,
                id: id.split('_')[1],
                propertyName: 'completeData',
                old: JSON.stringify({
                    timer_current_minutes: timerStartValuesRef.current.minutes,
                    timer_current_seconds: timerStartValuesRef.current.seconds,
                }),
                new: JSON.stringify({
                    timer_current_minutes: timerValueRef.current.minutes,
                    timer_current_seconds: timerValueRef.current.seconds,
                }),
            });
            timerStartValuesRef.current = null;
        }
        // Update manipulative with current countdown values
        isLocalUpdateRef.current = true;
        setManipulative(function (prev) {
            return prev.map(function (item) {
                return item.data.id === id
                    ? __assign(__assign({}, item), { data: __assign(__assign({}, item.data), { timer_current_minutes: timerValueRef.current.minutes, timer_current_seconds: timerValueRef.current.seconds, timer_is_running: false, timer_is_paused: true }) }) : item;
            });
        });
    };
    /** Stop timer and reset to initial values */
    var stopTimer = function () {
        // Capture stopped-at values BEFORE reset (for undo/redo)
        var stoppedMinutes = timerValueRef.current.minutes;
        var stoppedSeconds = timerValueRef.current.seconds;
        if (intervalRef.current)
            clearInterval(intervalRef.current);
        setIsRunning(false);
        setControlBtns(function (prev) {
            return prev.map(function (btn) {
                if (btn.id === 'start')
                    return __assign(__assign({}, btn), { disable: false });
                else if (btn.id === 'pause')
                    return __assign(__assign({}, btn), { disable: true });
                else if (btn.id === 'stop')
                    return __assign(__assign({}, btn), { disable: true });
                else
                    return __assign({}, btn);
            });
        });
        stopAudio('timerStopped');
        // Focus start button (now the primary action)
        requestAnimationFrame(function () { var _a; return (_a = btnRef.current[0]) === null || _a === void 0 ? void 0 : _a.focus(); });
        // Reset display to initial values
        setTimerMinutes(timer_minutes);
        setTimerSeconds(timer_seconds);
        timerValueRef.current = { minutes: timer_minutes, seconds: timer_seconds };
        // Save state: old=values when started, new=values when stopped (before reset)
        // if (timerStartValuesRef.current) {
        //   saveState({
        //     type: id,
        //     id: id.split('_')[1],
        //     propertyName: 'completeData',
        //     old: JSON.stringify({
        //       timer_current_minutes: timerStartValuesRef.current.minutes,
        //       timer_current_seconds: timerStartValuesRef.current.seconds,
        //     }),
        //     new: JSON.stringify({
        //       timer_current_minutes: stoppedMinutes,
        //       timer_current_seconds: stoppedSeconds,
        //     }),
        //   });
        //   timerStartValuesRef.current = null;
        // }
        // Save reset as separate undo entry (old=pre-reset values, new=initial values)
        // if (stoppedMinutes !== timer_minutes || stoppedSeconds !== timer_seconds) {
        saveState({
            type: id,
            id: id.split('_')[1],
            propertyName: 'completeData',
            old: JSON.stringify({
                timer_current_minutes: stoppedMinutes,
                timer_current_seconds: stoppedSeconds,
            }),
            new: JSON.stringify({
                timer_current_minutes: timer_minutes,
                timer_current_seconds: timer_seconds,
            }),
        });
        // }
        // Update manipulative with reset values
        isLocalUpdateRef.current = true;
        setManipulative(function (prev) {
            return prev.map(function (item) {
                return item.data.id === id
                    ? __assign(__assign({}, item), { data: __assign(__assign({}, item.data), { timer_current_minutes: timer_minutes, timer_current_seconds: timer_seconds, timer_is_running: false, timer_is_paused: false }) }) : item;
            });
        });
    };
    /** Cleanup interval on unmount */
    useEffect(function () {
        return function () {
            if (intervalRef.current)
                clearInterval(intervalRef.current);
        };
    }, []);
    /** ---------------- BOTTOM PANEL EVENT ---------------- */
    useEffect(function () {
        var onToolClick = function (data) {
            switch (data.id) {
                case 'edit':
                    // Pause the timer when opening edit
                    if (intervalRef.current)
                        clearInterval(intervalRef.current);
                    setIsRunning(false);
                    setControlBtns(function (prev) { return prev.map(function (btn) { return (__assign(__assign({}, btn), { disable: true })); }); });
                    setActiveManipulator('clocks');
                    setManiplulatorComponentVisible(true);
                    setSelectedManipulativeId(id);
                    isLocalUpdateRef.current = true;
                    setManipulative(function (prev) {
                        return prev.map(function (item) {
                            return item.data.id === id
                                ? __assign(__assign({}, item), { data: __assign(__assign({}, item.data), { updateStyleOnwhiteboard: false, timer_current_minutes: timerValueRef.current.minutes, timer_current_seconds: timerValueRef.current.seconds, timer_is_running: false, timer_is_paused: true }) }) : item;
                        });
                    });
                    break;
                case 'scaleMinus':
                    var oldScaleMinus = scale !== null && scale !== void 0 ? scale : 1;
                    var newScaleMinus_1 = Math.max(0.5, oldScaleMinus - 0.1);
                    saveState({
                        type: id,
                        id: id.split('_')[1],
                        propertyName: 'scale',
                        old: JSON.stringify(oldScaleMinus),
                        new: JSON.stringify(newScaleMinus_1),
                    });
                    announce(t('text.manipulativeScaled', {
                        name: t('text.manipulativeTimer'),
                        direction: t('text.down'),
                        value: newScaleMinus_1.toFixed(1),
                    }));
                    isLocalUpdateRef.current = true;
                    setManipulative(function (prevMan) {
                        return prevMan.map(function (_man) {
                            return _man.data.id === id
                                ? __assign(__assign({}, _man), { data: __assign(__assign({}, _man.data), { scale: newScaleMinus_1, timer_current_minutes: timerValueRef.current.minutes, timer_current_seconds: timerValueRef.current.seconds, timer_is_running: isRunning, timer_is_paused: !isRunning &&
                                            (timerValueRef.current.minutes !== timer_minutes ||
                                                timerValueRef.current.seconds !== timer_seconds) }) }) : _man;
                        });
                    });
                    break;
                case 'scalePlus':
                    var oldScalePlus = scale !== null && scale !== void 0 ? scale : 1;
                    var newScalePlus_1 = oldScalePlus + 0.1;
                    saveState({
                        type: id,
                        id: id.split('_')[1],
                        propertyName: 'scale',
                        old: JSON.stringify(oldScalePlus),
                        new: JSON.stringify(newScalePlus_1),
                    });
                    announce(t('text.manipulativeScaled', {
                        name: t('text.manipulativeTimer'),
                        direction: t('text.up'),
                        value: newScalePlus_1.toFixed(1),
                    }));
                    isLocalUpdateRef.current = true;
                    setManipulative(function (prevMan) {
                        return prevMan.map(function (_man) {
                            return _man.data.id === id
                                ? __assign(__assign({}, _man), { data: __assign(__assign({}, _man.data), { scale: newScalePlus_1, timer_current_minutes: timerValueRef.current.minutes, timer_current_seconds: timerValueRef.current.seconds, timer_is_running: isRunning, timer_is_paused: !isRunning &&
                                            (timerValueRef.current.minutes !== timer_minutes ||
                                                timerValueRef.current.seconds !== timer_seconds) }) }) : _man;
                        });
                    });
                    break;
                case 'start':
                    startTimer();
                    break;
                case 'pause':
                    pauseTimer();
                    break;
                case 'stop':
                    stopTimer();
                    break;
            }
        };
        if (isFocused) {
            customEventHandler.addEventListener('bottomPanel', onToolClick);
            // customEventHandler.addEventListener('colourChange', changeColour);
        }
        return function () {
            customEventHandler.removeEventListener('bottomPanel', onToolClick);
            // customEventHandler.removeEventListener('colourChange', changeColour);
        };
    }, [isFocused, scaling, scale, JSON.stringify(manipulative), onWhiteBoard]);
    var getClientPoint = function (e) {
        if ('touches' in e) {
            var touch = e.touches[0] || e.changedTouches[0];
            return {
                x: touch.clientX,
                y: touch.clientY,
            };
        }
        return {
            x: e.clientX,
            y: e.clientY,
        };
    };
    var onPositionDragStart = function (e) {
        var _a, _b;
        if ((lock === null || lock === void 0 ? void 0 : lock.positioning) || panningEnable) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        var _c = getClientPoint(e), x = _c.x, y = _c.y;
        var parentRect = (_b = (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
        if (!parentRect)
            return;
        var mouseXInParent = (x - parentRect.left) / zoomLevel;
        var mouseYInParent = (y - parentRect.top) / zoomLevel;
        positionDragRef.current = {
            startPos: { x: x, y: y },
            offset: {
                x: center.x - mouseXInParent,
                y: center.y - mouseYInParent,
            },
            hasMoved: false,
        };
        // Capture initial position for undo/redo
        dragStartPositionRef.current = { x: center.x, y: center.y };
        setIsDraggingSelf(true);
        window.addEventListener('mousemove', onPositionDragMove);
        window.addEventListener('touchmove', onPositionDragMove, {
            passive: false,
        });
        window.addEventListener('mouseup', onPositionDragEnd);
        window.addEventListener('touchend', onPositionDragEnd);
        startMultiDrag();
    };
    var onPositionDragMove = function (e) {
        var _a, _b;
        if (!positionDragRef.current)
            return;
        if ('touches' in e)
            e.preventDefault();
        var _c = getClientPoint(e), x = _c.x, y = _c.y;
        var _d = positionDragRef.current, startPos = _d.startPos, offset = _d.offset, hasMoved = _d.hasMoved;
        // Check if moved beyond threshold
        if (!hasMoved) {
            var dx = x - startPos.x;
            var dy = y - startPos.y;
            if (Math.sqrt(dx * dx + dy * dy) > 5) {
                positionDragRef.current.hasMoved = true;
            }
            else {
                return;
            }
        }
        var parentRect = (_b = (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
        if (!parentRect)
            return;
        var mouseXInParent = (x - parentRect.left) / zoomLevel;
        var mouseYInParent = (y - parentRect.top) / zoomLevel;
        var newX = mouseXInParent + offset.x;
        var newY = mouseYInParent + offset.y;
        // Track current position in ref for undo/redo (avoids stale closure in onPositionDragEnd)
        currentPositionRef.current = { x: newX, y: newY };
        isLocalUpdateRef.current = true;
        setManipulative(function (prev) {
            return prev.map(function (item) {
                return item.data.id === id
                    ? __assign(__assign({}, item), { data: __assign(__assign({}, item.data), { center: { x: newX, y: newY }, timer_current_minutes: timerValueRef.current.minutes, timer_current_seconds: timerValueRef.current.seconds, timer_is_running: isRunning, timer_is_paused: !isRunning &&
                                (timerValueRef.current.minutes !== timer_minutes ||
                                    timerValueRef.current.seconds !== timer_seconds) }) }) : item;
            });
        });
        // Multi-select: broadcast delta so other selected items follow
        if (dragStartPositionRef.current) {
            moveMultiDrag(newX - dragStartPositionRef.current.x, newY - dragStartPositionRef.current.y);
        }
    };
    var onPositionDragEnd = function (e) {
        if (!positionDragRef.current)
            return;
        setIsDraggingSelf(false);
        if (!positionDragRef.current.hasMoved) {
            setSelectedTool(selectTool(e, id, selectedTool, false));
        }
        else if (dragStartPositionRef.current && currentPositionRef.current) {
            // Position changed, save state for undo/redo
            var oldPosition = dragStartPositionRef.current;
            var newPosition = currentPositionRef.current;
            if (oldPosition.x !== newPosition.x || oldPosition.y !== newPosition.y) {
                var entry = {
                    type: id,
                    id: id.split('_')[1],
                    propertyName: 'center',
                    old: JSON.stringify(oldPosition),
                    new: JSON.stringify(newPosition),
                };
                if (!registerMultiSelectSaveEntries(id, [entry])) {
                    saveState(entry);
                }
            }
            // Move timer to end of manipulative array so it renders on top (matches Spinner/Dice).
            setManipulative(function (prev) {
                var index = prev.findIndex(function (item) { return item.data.id === id; });
                if (index === -1)
                    return prev;
                var updated = __spreadArray([], prev, true);
                var movedItem = updated.splice(index, 1)[0];
                updated.push(movedItem);
                return updated;
            });
            endMultiDrag();
        }
        positionDragRef.current.hasMoved = false;
        positionDragRef.current = null;
        dragStartPositionRef.current = null;
        currentPositionRef.current = null;
        window.removeEventListener('mousemove', onPositionDragMove);
        window.removeEventListener('touchmove', onPositionDragMove);
        window.removeEventListener('mouseup', onPositionDragEnd);
        window.removeEventListener('touchend', onPositionDragEnd);
    };
    var timerAriaLabel = onWhiteBoard
        ? (function () {
            var _a, _b, _c;
            var startDisabled = (_a = controlBtns.find(function (b) { return b.id === 'start'; })) === null || _a === void 0 ? void 0 : _a.disable;
            var pauseDisabled = (_b = controlBtns.find(function (b) { return b.id === 'pause'; })) === null || _b === void 0 ? void 0 : _b.disable;
            var stopDisabled = (_c = controlBtns.find(function (b) { return b.id === 'stop'; })) === null || _c === void 0 ? void 0 : _c.disable;
            if (isRunning)
                return t('text.timerRunning', {
                    minutes: timerMinute,
                    seconds: timerSecond,
                    total: timer_minutes,
                });
            if (startDisabled && pauseDisabled && !stopDisabled)
                return t('text.timerCompleteLabel');
            if (!startDisabled && pauseDisabled && !stopDisabled)
                return t('text.timerPausedLabel', {
                    minutes: timerMinute,
                    seconds: timerSecond,
                    total: timer_minutes,
                });
            return t('text.timerSetTo', { minutes: timer_minutes, seconds: timer_seconds });
        })()
        : undefined;
    return (_jsx(React.Fragment, { children: _jsx("div", { className: "timer-wrapper flexItem ".concat(id), ref: wrapperRef, "data-manipulative-id": id, role: "presentation", onKeyDown: onWhiteBoard
                ? function (e) {
                    var _a, _b;
                    if (panningEnable)
                        return;
                    var isDummyBtn = (_a = e.target) === null || _a === void 0 ? void 0 : _a.closest('.dummy_btn');
                    // Auto-select timer when any key is pressed on dummy button
                    if (isDummyBtn && !selectedTool.includes(id)) {
                        setSelectedTool([id]);
                    }
                    // Context menu: Enter, Space, Shift+F10, ContextMenu key
                    if (isDummyBtn &&
                        (e.key === 'Enter' ||
                            e.key === ' ' ||
                            e.key === 'ContextMenu' ||
                            (e.shiftKey && e.key === 'F10'))) {
                        e.preventDefault();
                        e.stopPropagation();
                        var rect = (_b = wrapperRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
                        if (rect) {
                            setContextMenu({ x: rect.right + 8, y: rect.top, manipulativeId: id });
                        }
                        return;
                    }
                    // Arrow keys: move timer (only when dummy button is focused)
                    if (isDummyBtn && !(lock === null || lock === void 0 ? void 0 : lock.positioning)) {
                        var STEP = e.shiftKey ? 50 : 10;
                        var delta = {
                            ArrowUp: { x: 0, y: -STEP, dir: t('text.up') },
                            ArrowDown: { x: 0, y: STEP, dir: t('text.down') },
                            ArrowLeft: { x: -STEP, y: 0, dir: t('text.left') },
                            ArrowRight: { x: STEP, y: 0, dir: t('text.right') },
                        };
                        if (delta[e.key]) {
                            e.preventDefault();
                            e.stopPropagation();
                            var d = delta[e.key];
                            var oldCenter = center !== null && center !== void 0 ? center : { x: 0, y: 0 };
                            var newCenter_1 = { x: oldCenter.x + d.x, y: oldCenter.y + d.y };
                            setManipulative(function (prev) {
                                return prev.map(function (m) {
                                    return m.data.id === id ? __assign(__assign({}, m), { data: __assign(__assign({}, m.data), { center: newCenter_1 }) }) : m;
                                });
                            });
                            announce(t('text.manipulativeMoved', {
                                name: t('text.timer'),
                                direction: d.dir,
                                x: Math.round(newCenter_1.x),
                                y: Math.round(newCenter_1.y),
                            }));
                        }
                    }
                }
                : undefined, style: onWhiteBoard
                ? {
                    transform: "translate(-50%, -50%) scale(".concat(scaling, ")"),
                    height: "".concat((_c = _clockData.dimensions) === null || _c === void 0 ? void 0 : _c.height, "px"),
                    width: "".concat((_d = _clockData.dimensions) === null || _d === void 0 ? void 0 : _d.width, "px"),
                    // height: `calc(${_clockData.dimensions?.height}px + ${paddingAround} + ${paddingAround})`,
                    // width: `calc(${_clockData.dimensions?.width}px + ${paddingAround} + ${paddingAround})`,
                    position: 'absolute',
                    left: "".concat(Math.round(_clockData.center.x), "px"),
                    top: "".concat(Math.round(_clockData.center.y), "px"),
                    transformOrigin: "center center",
                    borderRadius: "23px",
                    boxShadow: "0 0 20px ".concat(isFocused ? '#5063AE' : 'transparent'),
                    cursor: (lock === null || lock === void 0 ? void 0 : lock.positioning) || panningEnable ? 'inherit' : 'pointer',
                    zIndex: isDraggingSelf ? 999 : undefined,
                }
                : {
                    pointerEvents: 'none',
                    cursor: 'inherit',
                }, children: _jsxs("div", { className: "display-box flexItem", children: [onWhiteBoard && (_jsx(ButtonComponent, { defaultCSS: 'dummy_btn', normalCSS: 'dummy_btnGrp', text: "", role: "group", ariaLabel: (_f = (_e = timerDuplicateLabel !== null && timerDuplicateLabel !== void 0 ? timerDuplicateLabel : timerCreationLabel) !== null && _e !== void 0 ? _e : timerAriaLabel) !== null && _f !== void 0 ? _f : '', ariaRoledescription: t('text.manipulativeTimer'), clickHandler: function (e) {
                            var _a;
                            setSelectedTool(selectTool(e, id, selectedTool, false));
                            // VoiceOver synthetic clicks have detail === 0; real taps have detail === 1
                            var isVoiceOverClick = IS_TOUCH_DEVICE && e.detail === 0;
                            if (isVoiceOverClick) {
                                var rect = (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
                                if (rect) {
                                    setContextMenu({ x: rect.right + 8, y: rect.top, manipulativeId: id });
                                }
                            }
                        }, isActive: false, onMouseDown: onPositionDragStart, onTouchStart: onPositionDragStart })), _jsxs("div", { className: "display-box-child flexItem", children: [_jsx("div", { className: "timer-display", role: "status", "aria-live": "polite", "aria-atomic": "true", "aria-label": isRunning
                                    ? t('text.timerDisplayRunning', { minutes: timerMinute, seconds: timerSecond })
                                    : t('text.timerDisplay', { minutes: timerMinute, seconds: timerSecond }), children: _jsxs("div", { className: "timer-display-child flexItem", "aria-hidden": "true", children: [_jsxs("span", { className: "big ".concat(onWhiteBoard ? 'threeSize' : ''), children: [_jsx("span", { children: pad(timerMinute)[0] }), _jsx("span", { children: pad(timerMinute)[1] })] }), _jsx("span", { className: "sub ".concat(onWhiteBoard ? 'threeSize' : ''), children: "m" }), _jsx("span", { className: "colon ".concat(onWhiteBoard ? 'threeSize' : ''), children: " : " }), _jsxs("span", { className: "big ".concat(onWhiteBoard ? 'threeSize' : ''), children: [_jsx("span", { children: pad(timerSecond)[0] }), _jsx("span", { children: pad(timerSecond)[1] })] }), _jsx("span", { className: "sub ".concat(onWhiteBoard ? 'threeSize' : ''), children: "s" })] }) }), _jsx("div", { className: "controls", "aria-hidden": !onWhiteBoard || undefined, children: _jsx("div", { className: "controls-child flexItem ".concat(onWhiteBoard ? '' : 'disableGrpControls'), role: onWhiteBoard ? 'toolbar' : undefined, "aria-label": onWhiteBoard ? t('text.timerControls') : undefined, "aria-orientation": "horizontal", style: onWhiteBoard
                                        ? {}
                                        : { pointerEvents: 'none', cursor: 'inherit' }, onKeyDown: onWhiteBoard
                                        ? function (e) {
                                            var _a;
                                            if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key))
                                                return;
                                            e.preventDefault();
                                            e.stopPropagation();
                                            var enabledBtns = controlBtns
                                                .map(function (btn, i) { return (__assign(__assign({}, btn), { idx: i })); })
                                                .filter(function (btn) { return !btn.disable; });
                                            if (!enabledBtns.length)
                                                return;
                                            var currentIdx = enabledBtns.findIndex(function (btn) { return btnRef.current[btn.idx] === document.activeElement; });
                                            var nextIdx;
                                            if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
                                                nextIdx = currentIdx >= enabledBtns.length - 1 ? 0 : currentIdx + 1;
                                            }
                                            else {
                                                nextIdx = currentIdx <= 0 ? enabledBtns.length - 1 : currentIdx - 1;
                                            }
                                            (_a = btnRef.current[enabledBtns[nextIdx].idx]) === null || _a === void 0 ? void 0 : _a.focus();
                                        }
                                        : undefined, children: controlBtns.map(function (ele, ind) {
                                        return (_jsx(ButtonComponent, { defaultCSS: "".concat(ele.id, " btn ").concat(onWhiteBoard ? 'threeSize' : ''), normalCSS: "_".concat(ele.id), imgSrc: btnConfig[ele.id].imgSrc, ariaLabel: ele.id === 'start'
                                                ? 'text.startTimer'
                                                : ele.id === 'pause'
                                                    ? 'text.pauseTimerBtn'
                                                    : 'text.stopAndResetTimer', clickHandler: function () {
                                                if (ele.id === 'start')
                                                    startTimer();
                                                else if (ele.id === 'pause')
                                                    pauseTimer();
                                                else if (ele.id === 'stop')
                                                    stopTimer();
                                            }, disabled: ele.disable, ariaHidden: !onWhiteBoard, tabIndex: !onWhiteBoard ? -1 : ele.disable ? -1 : 0, reference: function (el) {
                                                if (!btnRef.current)
                                                    return;
                                                btnRef.current[ind] = el;
                                            } }, ele.id));
                                    }) }) })] })] }) }) }));
}
